import styled from "styled-components";

export const Container = styled.div`
  width: 500px;
  display: flex;
  gap: 8px;
  padding: 0 32px 16px 32px;
`;

export const Card = styled.div`
  width: 100%;
  padding: 8px;
  gap: 16px;
  background-color: white;
  border-radius: 8px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

export const SubCard = styled.div`
  width: 100%;
  padding: 8px;
  margin-top: 16px;
  background-color: #fff3e1;
  border-radius: 8px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SubtitleHeader = styled.a`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;

  color: #2d5bff;
`;

export const IconHeader = styled.a`
  width: 58px;
  height: 58px;
  background-color: #eaefff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
`;

export const HeaderCard = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
`;

export const BodyCard = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Text = styled.p`
  margin-bottom: 4px;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;

  word-break: break-all;
  word-wrap: break-word;
`;

export const Subtitle = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;
  color: #8e8e8e;

  word-break: break-all;
  word-wrap: break-word;
`;

export const SubCardTitle = styled.p`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;
  color: #333333;

  word-break: break-all;
  word-wrap: break-word;
`;
